<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add Library">
      <div class="row">
         <div class="col-md-6 form-group">
          Parent Library
          <b-form-select id="parent" v-model="parentLibrary"><option value="Add New Parent Library">Add New Parent Library</option></b-form-select>
        </div>
        <div class="col-md-6 form-group" v-if="parentLibrary == 'Add New Parent Library'">
          Parent Library Name
          <input id="parentLibraryName" v-model="parentLibraryName" class="form-control" type="text" />
        </div>
        <div class="text-center col-md-12 form-group" v-if="parentLibraryName != '' && parentLibrary == 'Add New Parent Library'">
        <b-button
          class="text-center"
          variant="success"
          style="margin-bottom: 20px"
          @click="insert()"
          >Insert</b-button
        >
      </div>
        <div class="col-md-6 form-group" v-if="parentLibrary != 'Add New Parent Library' && parentLibrary != ''">
          Name
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group" v-if="parentLibrary != 'Add New Parent Library' && parentLibrary != ''">
          Description
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group" v-if="parentLibrary != 'Add New Parent Library' && parentLibrary != ''">
          Image
          <b-form-file id="file-small"></b-form-file>
        </div>
        <div class="col-md-6 form-group" v-if="parentLibrary != 'Add New Parent Library' && parentLibrary != ''">
          Document
          <b-form-file id="file-small"></b-form-file>
        </div>
        <div class="col-md-6 form-group" v-if="parentLibrary != 'Add New Parent Library' && parentLibrary != ''">
          Document Access
          <b-form-checkbox v-model="viewAccess">View</b-form-checkbox>
          <b-form-checkbox v-model="downloadAccess">Download</b-form-checkbox>
        </div>
        <div class="col-md-6 form-group" v-if="parentLibrary != 'Add New Parent Library' && parentLibrary != ''">
          Status
          <b-form-select v-model="selected1" :options="options"></b-form-select>
        </div>
      </div>
      <div class="text-center" v-if="parentLibrary != 'Add New Parent Library' && parentLibrary != ''">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          >Save</b-button
        >
      </div>
    </base-block>
    <br />
  </div>
</template>

<script>
export default {
  methods: {
    insert() {
    var parent = document.getElementById("parent");
       var option = document.createElement("OPTION");
       option.innerHTML = document.getElementById("parentLibraryName").value;
       option.value = document.getElementById("parentLibraryName").value;
       parent.options.add(option);
       this.parentLibraryName = ""
    }
  },
  data() {
    return {
      viewAccess: "",
      downloadAccess: "",
      parentLibraryName: "",
      selected1: "",
      options: [{ text: "Active" }, { text: "Deactive" }],
      parentLibrary: ""
    };
  },
};
</script>

